export enum Role {
  OpengovAdmin = "opengov_admin", // Internal company admin.
  OpengovEngineer = "opengov_engineer", // Internal engineer.
  OpengovSales = "opengov_sales", // Internal sales rep.
  OpengovTSD = "opengov_tsd", // Internal sales development rep.
  OpengovUser = "opengov_user", // A company employee.
  EntityUser = "entity_user", // A customer.
  EntityAdmin = "entity_admin", // A customer with admin privileges.
  EntityGroupPartner = "entity_group_partner", // A customer that is a partner.
}

export type UserRole = {
  display_name: string;
  name: Role;
};

export type User = {
  uuid: string;
  id: number;
  email: string;
  avatar?: string;
  first_name: string;
  full_name: string;
  last_name: string;
  role: UserRole;
  disabled?: boolean;
};

export type UserGroup = {
  id: string;
  name: string;
  description: string;
  entityId: string;
  memberCount: number;
  createdAt: string;
  updatedAt: string;
};

export type UserGroupMember = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  disabled: boolean;
  lastSeen: string;
};

export type UserGroupsMembersQueryResult = {
  members: UserGroupMember[];
};

export type UserGroupMembersIdsMap = Record<string, string[] | undefined>;

export type UserGroupWithUserIds = UserGroup & {
  userIds: string[];
};

export type NameToIdAndTypeMap = Record<string, { id: string; type: "USER" | "GROUP" }>;
